// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "baggageList__footer-39wKD";
var _3 = "baggageList__add-bQJW2";
export { _1 as "__esModule", _2 as "baggageList__footer", _3 as "baggageList__add" }
export default { "__esModule": _1, "baggageList__footer": _2, "baggageList__add": _3 }
